import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import * as get from 'lodash/get';

import { StepNavigationService } from './service/step-navigation.service';

@UntilDestroy()
@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'ac-step-nav',
	templateUrl: './step-navigation.component.html',
	styleUrls: ['./step-navigation.component.scss']
})
export class StepNavigationComponent implements OnInit {
	@Input() public routes;

	public currentPathIndex: number = 0;
	public queryParams: any;

	constructor(private router: Router, private stepNavigationService: StepNavigationService, private route: ActivatedRoute) { }

	public ngOnInit(): void {
		if (get(this.router, 'url')) {
			this.currentPathIndex = this.stepNavigationService.getCurrentPathIndex(this.routes);
		}
		this.route.queryParams.subscribe(params => {
			this.queryParams = params;
		});
		this.router.events.pipe(untilDestroyed(this)).subscribe(event => this.currentPathIndex = this.stepNavigationService.getCurrentPathIndex(this.routes));
	}
}
